import { Quota } from '../../shared/models/quota'
import { baseArkhaleAPI } from './base-api'

const quotaApi = baseArkhaleAPI.injectEndpoints({
  endpoints: (build) => ({
    getSelfQuota: build.query<Quota, void>({
      query: () => ({
        url: 'quotas/self',
        method: 'GET',
      }),
    }),
  }),
})

export const { useGetSelfQuotaQuery, useLazyGetSelfQuotaQuery } = quotaApi
